// See https://developers.google.com/doubleclick-gpt/common_implementation_mistakes.
//
// Assuming that the GPT API is ready to be called when the JavaScript file gpt.js is loaded is wrong, as some parts
// of the API are provided by the pubads_impl.js file. Relying in any way (including frameworks) on the API from within
// event listeners attached to the script tag is therefore incorrect.

export function setTargeting (user, attributes, googletag) {
  if (user) {
    googletag.pubads().setTargeting('gender', attributes.gender)
    googletag.pubads().setTargeting('age_group', attributes.ageGroup)
    googletag.pubads().setTargeting('daysmember', attributes.daysSinceJoined)
    googletag.pubads().setTargeting('user_city', attributes.city)
    googletag.pubads().setTargeting('user_state', attributes.state)
    googletag.pubads().setTargeting('user_stat2', attributes.bmiCode)
    googletag.pubads().setTargeting('country_co', attributes.countryCode)
  }
  googletag.pubads().setTargeting('is_mvp', 'no')
  googletag.pubads().setTargeting('page_url', attributes.url)
  googletag.pubads().setTargeting('ssl', attributes.ssl)
}

export default function initDFP (user, attributes = {}, googletag) {
  googletag.cmd.push(setTargeting.bind(null, user, attributes, googletag))
}

